// Property names for Form Settings

const FormSettings = {
	BRIEF_DESCRIPTION : 'briefDescription',
	CLOSE_SCHEDULE: 'close',
	CONFIRMATION_DESTINATION: 'confirmationDestination',
	CONFIRMATION_LINK: 'confirmationLink',
	CONFIRMATION_MESSAGE: 'confirmationMessage',
	CONFIRMATION_EMAIL_CUSTOM_CONTENT: 'confirmationEmailContent',
	//CURRENCY: 'currency',
	EDLIO_PAY: 'edlioPay',
	FORM_CLOSED_MESSAGE: 'formClosedMessage',
	INCLUDE_CAPTCHA: 'includeCaptcha',
	INCLUDE_RESPONSE_IN_ADMIN_DIGEST: 'includeResponseInAdminDigest',
	INCLUDE_RESPONSE_IN_CONFIRMATION: 'includeResponseInConfirmationEmail',
	LIMIT_SUBMISSIONS: 'limitSubmissions',
	SUBMISSION_MAX: 'submissionMax',
	NOTIFICATION_EMAIL_LIST: 'notificationEmailAddresses',
	OPEN_SCHEDULE: 'open',
	PASSWORD_PROTECTION: 'requirePassword',
	PRE_OPEN_MESSAGE: 'preOpenMessage',
	REQUIRE_CONFIRMATION_EMAIL: 'requireConfirmationEmail',
	SHOW_CONFIRMATION_EMAIL_INPUT: 'showConfirmationEmailInput',
	SHOW_EDIT_RESPONSE_LINK: 'showEditResponseLink',
	SHOW_RESPONSE_SUMMARY: 'showResponseSummary',
	SHOW_SUBMIT_ANOTHER_RESPONSE_LINK: 'showSubmitAnotherResponseLink',
	STRIPE_ACCOUNT: 'stripeAccount',
	SUBMISSION_ENCRYPTION: 'encryptSubmissions',
	SUBMIT_BUTTON_LABEL: 'submitButtonLabel',
	SCHEDULE: 'schedule',
	COLLECT_PAYMENT: 'collectPayment',
	TRANSFER_FEE: 'transferFee',
	PAYMENT_FORM: 'paymentForm',
	GL_ACCOUNT: 'glAccount'
}

export default FormSettings;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/form-settings.js